import { Axis, Movements } from '@studio/models/ptz';
import type { PTZ } from '@studio/models/ptz';
import { toEnumValues } from '@tryiris-ai/js-types';
import type { Writable } from 'type-fest';
import { moveTo } from './move-to.js';
import type { QuickMove } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { pbToJsPtz } from '#~/protobuf/index.js';

/**
 * Perform quick move.
 *
 * @param deviceId - The ID of the device to be moved.
 * @param movement - Camera movement.
 */
export const quickMove: QuickMove = async (deviceId, movement, cine, options) => {
  const proxy = locateProxy(deviceId);

  if (!proxy) {
    return;
  }

  // Get the current position of this device.
  const intent: Writable<PTZ> = pbToJsPtz(proxy.state.status?.device[deviceId]?.movement?.position);

  toEnumValues(Axis).forEach((axis) => {
    const magnitude = Movements[movement].ptz[axis];

    if (magnitude) {
      intent[axis] = magnitude;
    }
  });

  // Move the camera
  await moveTo(deviceId, intent, cine, {
    toolUsed: options?.toolUsed ?? 'quick_move'
  });
};
